export const GET_DASHBOARD_REQUEST = 'GET_DASHBOARD_REQUEST';
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
export const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE';

export const GET_FILTERED_WEARABLES_REQUEST = 'GET_FILTERED_WEARABLES_REQUEST';
export const GET_FILTERED_WEARABLES_SUCCESS = 'GET_FILTERED_WEARABLES_SUCCESS';
export const GET_FILTERED_WEARABLES_FAILURE = 'GET_FILTERED_WEARABLES_FAILURE';